import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { CautionPill } from "components/caution";

const MONTH_YEAR = "MMM yyyy";

export const EarliestDataPill = ({ date }: { date: Date }) => {
  const { t } = useTranslation(["productDetails"]);
  return (
    <CautionPill>
      {t("productDetails:salesData.effectiveWindow.earliestDataPill", {
        date: format(date, MONTH_YEAR),
      })}
    </CautionPill>
  );
};
